module.exports = __webpack_public_path__ + "img/show-logo-mobile.c3f31adc.png";